module.exports = __webpack_public_path__ + "static/media/undraw_schedule_pnbk.72bb679a.svg";